import React from "react";

export const timeDayToDisplayTimeslot = (hour, day) => {
  return `${hour.toString().padStart(2, "0")}:00 - ${(hour + 1).toString().padStart(2, "0")}:00 CET`
}
